import React from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

const ModalMap = ({ openModalMap, handleCloseModalMap, dataOnclick }) => {
    return (
        <Dialog open={openModalMap} onClose={handleCloseModalMap} className="relative z-[100]">
            {/* Backdrop พร้อม Blur effect เพื่อความทันสมัย */}
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-500 data-[leave]:duration-300 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-[2.5rem] bg-white text-left shadow-2xl transition-all data-[closed]:translate-y-12 data-[closed]:opacity-0 data-[enter]:duration-500 data-[leave]:duration-300 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 border border-slate-100"
                    >
                        {/* Header Section พร้อมแถบสีส้มบางๆ ด้านบน */}
                        <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-orange-400 to-orange-600"></div>

                        <div className="bg-white px-6 pb-6 pt-8 sm:p-8">
                            <div className="sm:flex sm:items-start">
                                <div className="w-full">
                                    <DialogTitle as="h3" className="flex items-center gap-3 text-2xl font-black leading-6 text-slate-800 tracking-tight">
                                        <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-orange-100 text-orange-600 shadow-sm">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                                            </svg>
                                        </div>
                                        <div className="flex flex-col">
                                            <span>แผนที่ตำแหน่งบริการ</span>
                                            <span className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-1">Google Maps Location</span>
                                        </div>
                                    </DialogTitle>
                                    
                                    <div className="mt-6">
                                        <div className="text-sm text-gray-500">
                                            {dataOnclick?.map?.split(',')[1] === undefined ? (
                                                <div className="flex flex-col items-center justify-center py-20 bg-slate-50 rounded-[2rem] border-2 border-dashed border-slate-200">
                                                    <div className="p-4 bg-white rounded-full shadow-sm mb-4">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 text-slate-300">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008h-.008v-.008Z" />
                                                        </svg>
                                                    </div>
                                                    <p className="text-center font-bold text-slate-400">ขออภัย! ไม่พบข้อมูลแผนที่สำหรับหน่วยงานนี้</p>
                                                </div>
                                            ) : (
                                                <div className="overflow-hidden rounded-[2rem] border border-slate-200 shadow-inner bg-slate-50 relative group">
                                                    {/* กล่องบรรจุ Map iframe ที่ปรับให้เต็มขอบสวยงาม */}
                                                    <div 
                                                        className="flex justify-center transition-transform duration-500 group-hover:scale-[1.01]" 
                                                        dangerouslySetInnerHTML={{ __html: dataOnclick?.map?.split(',')[1] }}
                                                    ></div>
                                                    
                                                    {/* Overlay ตกแต่งเล็กน้อยเมื่อ Hover */}
                                                    <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-black/5 rounded-[2rem]"></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* ชื่อสถานที่ด้านล่างแผนที่ */}
                                    <div className="mt-4 px-2">
                                        <p className="text-sm font-bold text-slate-700">
                                            <span className="text-orange-500 mr-2">📍</span>
                                            {dataOnclick?.hname || 'หน่วยบริการฟอกเลือด'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer Section พร้อมปุ่มดีไซน์ใหม่ */}
                        <div className="bg-slate-50 px-6 py-4 sm:flex sm:flex-row-reverse sm:px-8">
                            <button
                                type="button"
                                onClick={() => handleCloseModalMap()}
                                className="inline-flex w-full justify-center items-center gap-2 rounded-2xl bg-slate-900 px-8 py-3 text-sm font-black text-white shadow-xl shadow-slate-200 hover:bg-orange-600 hover:shadow-orange-200 transition-all duration-300 active:scale-95 sm:w-auto"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-4 h-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                                ปิดหน้าต่าง
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}

export default ModalMap